import { render } from "./ConfirmaEmail.vue?vue&type=template&id=5b18cc7c&scoped=true"
import script from "./ConfirmaEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmaEmail.vue?vue&type=script&lang=js"

import "./ConfirmaEmail.vue?vue&type=style&index=0&id=5b18cc7c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b18cc7c"]])

export default __exports__